export default {

    // 生成19位UUID
	createOrgUUID() {
		return wx.UUID.createShortUUID();
	},

    // 去掉fid中的组织类型
	fidToIDPath(fid) {
		return fid.replace(/\.\w+/g, "");
	},

    // 将fid、fname转成数组
    fullToArr(full) {
        if (!full) return [];
        let separator = full.substr(0, 1);
        let arr = full.split(separator);
        arr.splice(0, 1);
        return arr;
    },

    // 从fid和fname中获取机构的id和name
    getOgn(fid, fname) {
        return this.getOrg(fid, fname, "ogn");
    },

    // 从fid和fname中获取部门的id和name
    getDept(fid, fname) {
        return this.getOrg(fid, fname, "dpt");
    },

    // 从fid和fname中获取岗位的id和name
    getPos(fid, fname) {
        return this.getOrg(fid, fname, "pos");
    },

    // 从fid和fname中获取指定组织类型的id和name
    getOrg(fid, fname, orgType) {
        let idArr = this.fullToArr(fid);
        let nameArr = this.fullToArr(fname);
        let pos;
        for (let i = idArr.length - 1; i >= 0; i--) {
            if (idArr[i].endsWith(orgType)) {
                pos = i;
                break;
            }
        }
        return {
            id: pos >= 0 ? idArr[pos].split(".")[0] : "",
            name: pos >= 0 ? nameArr[pos] : ""
        };
    },

    // 从fid和fname中获取顶级组织的id和name
    getRootOrg(fid, fname) {
        return this.getLevelOrg(fid, fname, 1);
    },

    // 从fid和fname中获取父组织的id和name
    getParentOrg(fid, fname) {
        return this.getLevelOrg(fid, fname, -1);
    },

    // 从fid和fname中获取指定层级组织的id和name
    getLevelOrg(fid, fname, level) {
        let idArr = this.fullToArr(fid);
        let nameArr = this.fullToArr(fname);
        let pos = level > 0 ? level - 1 : idArr.length + level - 1;
        return {
            id: (pos < idArr.length && pos >= 0) ? idArr[pos].split(".")[0] : "",
            name: (pos < idArr.length && pos >= 0) ? nameArr[pos] : ""
        };
    }
};
